import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=231bd7b4&"
import script from "./Network.vue?vue&type=script&lang=js&"
export * from "./Network.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports